function formBuySubmit() {
	let route = $(this).attr('action');
	let $modal = $(this).closest(".modal");

	let $btn = $modal.find('button[type=submit]');
	let prevText = $btn.text();
	$btn.text('Оформляем заказ...').attr('disabled', 'disabled');

	let $msgError = $modal.find('.msg.msg-error');
	$msgError.hide();

	$.ajax({
		type: 'POST',
		url: route,
		data: new FormData($(this).get(0)),
		processData: false,
		contentType: false,
		success: function(data) {
			$btn.text(prevText).removeAttr('disabled');
			if (data.error) {
				$msgError.text(data.msg).show();
			} else {
				window.yaCounterReachGoal('order');
				location.href = data.redirect_to;
			}
		}
	});

	return false;
}

$(document).on('submit', '#form-cart-buy', formBuySubmit);
$(document).on('submit', '#form-cart-buy-oftalma-webinar', formBuySubmit);
$(document).on('submit', '#form-cart-buy-nmo:not([data-vgformsender])', formBuySubmit);
